import { sidebarConfig, useSidebarOpenState } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthOpen,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: -14,
  },
  linkOpen: {
    width: sidebarConfig.drawerWidthOpen,
    display: 'flex',
    justifyContent: 'center',
  },
  linkClosed: {
    width: sidebarConfig.drawerWidthClosed,
    display: 'flex',
    justifyContent: 'center',
  },
});

export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();
  const linkClassName = isOpen ? classes.linkOpen : classes.linkClosed;

  return (
    <div className={classes.root}>
      <Link
        to="/"
        className={linkClassName}
        aria-label="Home"
        style={{ textDecoration: 'none' }}
      >
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};
